import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export enum SiteCEPPConfigurationState {
    NOT_ENABLED = 'NOT_ENABLED',
    IN_PROGRESS = 'IN_PROGRESS',
    PENDING_VERIFICATION = 'PENDING_VERIFICATION',
    ACTIVE = 'ACTIVE',
    FAILED = 'FAILED',
    DEACTIVATED = 'DEACTIVATED'
}

export interface ActivityLogSecurityVerificationFile {
    fileContent: string;
}

export interface SiteCEPPConfiguration {
    awsAccountNumber: string;
    s3BucketName: string;
    kmsKeyARN: string;
}

export interface ISiteCEPPStatusResult extends IResult {
    siteCEPPConfigurationState: SiteCEPPConfigurationState;
    siteCEPPConfiguration: SiteCEPPConfiguration;
    error: string;
}

export interface IActivityLogConnection {
    configuration: SiteCEPPConfiguration;
    connectionStatus: SiteCEPPConfigurationState;
}
